import { Inject, Injectable, InjectionToken } from '@angular/core';
import * as Highcharts from 'highcharts';

export const HIGHCHARTS_MODULES = new InjectionToken<any[]>('HighchartsModules');

@Injectable()
export class ChartsService {
  public constructor(@Inject(HIGHCHARTS_MODULES) private readonly chartModules: any[]) {
  }

  public initModules(): void {
    this.chartModules.forEach(chartModule => {
      chartModule(Highcharts);
    });
  }
}
